import { defineStore } from 'pinia'
import { watch, ref, toValue, computed } from 'vue'
import { omit, pick } from 'lodash-es'
import { useRoute, useRouter } from 'vue-router'

const model = ['page', 'onPage', 'search', 'order_direction', 'order_field', 'filter', 'filter_id']

export const useListStore = defineStore('list', () => {
  const router = useRouter()
  const route = useRoute()

  // На главной несколько списков с разным persistKey — общий ключ route.name не используем, чтобы page/onPage не попадали в URL и не смешивались между списками
  let startValue
  if (route.name === 'home') {
    startValue = {}
  } else {
    const picked = pick(route.query, model)
    if (Object.keys(picked).length) {
      startValue = { [route.name]: picked }
    } else {
      startValue = {}
    }
  }

  const history = ref(startValue)
  const historyItem = computed(() => history.value[route.name])

  /** Key for a list state: route.name or route.name + '#' + persistKey (e.g. home#orders_my). */
  function storageKey(persistKey) {
    return persistKey ? `${route.name}#${persistKey}` : route.name
  }

  function getHistoryItem(persistKey) {
    return history.value[storageKey(persistKey)]
  }

  router.beforeResolve((to, _, next) => {
    const hst = history.value[to.name]
    if (!hst) {
      next()
      return
    }
    if (Object.keys(hst).every(q => to.query[q] == hst[q])) {
      next()
      return
    }
    next({ ...to, query: { ...to.query, ...hst } })
  })

  watch(history, h => {
    for (const [p, q] of Object.entries(h)) {
      if (route.name !== p) continue
      const same = model.every(k => route.query[k] == q[k])
      if (same) return
      fromHistoryToRoute(q)
      break
    }
  })

  function save(v, persistKey) {
    const key = storageKey(persistKey)
    const val = { ...history.value }
    if (v === undefined) {
      delete val[key]
    } else {
      val[key] = toValue(v)
    }
    history.value = val
  }

  function fromHistoryToRoute(q) {
    const query = omit(route.query, model)
    Object.assign(query, q)
    router.push({ ...route, query })
  }

  return {
    history,
    historyItem,
    save,
    getHistoryItem,
    storageKey,
  }
})
